<template>
    <app-layout>
        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-2/3 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg sm:p-6 lg:p-8">
                    <p class="text-xl text-center mt-4">
                        Now let's get you a phone number!
                    </p>
<!--                    <p class="text-sm italic text-center mb-4">-->
<!--                        Toll-free numbers are the industry standard for text-->
<!--                        message reminder and marketing applications. <br />All-->
<!--                        numbers are capable of SMS and MMS (picture) messaging.-->
<!--                    </p>-->
                    <p class="text-sm italic text-center mb-4">
                        Please enter the area code for the phone number you'd like to use.
                    </p>
                    <available-phone-number-selector
                        v-model="selectedNumber"
                        ref="numberSelector"
                    ></available-phone-number-selector>

                    <div class="mt-4 flex justify-end">
                        <jet-button
                            @click.native="purchaseNumber()"
                            :disabled="!selectedNumber || loading"
                            class="bg-gray-400"
                            >Complete</jet-button
                        >
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "../../Jetstream/Button";
import AvailablePhoneNumberSelector from "../../components/AvailablePhoneNumberSelector";
import axios from "axios";


export default {
    components: { AvailablePhoneNumberSelector, AppLayout, JetButton },
    name: "Index",
    props: [],
    mounted() {},
    data() {
        return {
            selectedNumber: "",
            loading: false,
        };
    },
    computed: {},
    methods: {
        purchaseNumber() {
            let vm = this;
            vm.loading = true;
            axios
                .post(route("provision-number"), {
                    phone_number: vm.selectedNumber.phoneNumber
                })
                .then(function(response) {
                    vm.$toasted.show(response.data.message, {
                        position: "bottom-right",
                        type: "success",
                        duration: 3000
                    });

                    try {
                        window.dataLayer.push({
                            event: "purchased-number"
                        });
                    } catch (e) {}
                    vm.loading = false;
                    vm.$inertia.visit("/");
                })
                .catch(function(error) {
                    vm.$toasted.show(error.response.data.message, {
                        position: "bottom-right",
                        type: "error",
                        duration: 3000
                    });
                    vm.loading = false;
                    vm.$refs.numberSelector.getAvailableLocalNumbers();
                });
        }
    }
};
</script>

<style>
div > label {
    font-weight: bold;
}

.progress-bar {
    display: flex;
    justify-content: space-between;
    background: none;
    position: relative;
}
.number {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eee;
    line-height: 0.86;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    position: relative;
    z-index: 1;
}

.line {
    position: absolute;
    width: 100%;
    top: calc(50% - 2px);
    height: 4px;
    background: #eee;
}

.active {
    @apply bg-blue-500;
    color: #fff;
}

.circle-select {
    @apply border border-gray-500 ml-4;

    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.selected .circle-select {
    @apply bg-blue-200 border-blue-700;
}

.toggle-checkbox:checked {
    @apply right-0 border-blue-600;
    right: 0;
}

.toggle-checkbox:checked + .toggle-label {
    @apply bg-blue-600;
}
</style>
